/**
 * Array of Attitude to Risk (ATR) options used for risk profiling.
 * Each option contains a `value` representing the risk level (as a string)
 * and a `label` describing the risk profile with its corresponding percentage.
 *
 * @type {Array<{ value: string, label: string }>}
 * @example
 * // Example usage:
 * // Display ATR options in a dropdown menu
 * ATROptions.map(option => <option value={option.value}>{option.label}</option>);
 */
const ATROptions = [
  { value: "5", label: "Adventurous 5%" },
  { value: "4", label: "Dynamic 4%" },
  { value: "3", label: "Moderate 3%" },
  { value: "2", label: "Balanced 2%" },
  { value: "1", label: "Conservative 1%" },
  { value: "0", label: "Risk Averse 0%" },
];

export default ATROptions;
